import ACTIONS from "./action";
import commonReducers from "@tailormed/common-client/store/reducer";

const defaultState = {
  idpConfig: undefined,
  oktaClientId: undefined,
  environment: undefined,
  user: undefined,
  notificationPreferences: undefined,
  selectedAssistanceProgram: undefined,
  showAssistanceProgramModal: false,
  showSupport: {
    visible: false,
    assistancePrograms: undefined
  },
  assistancePrograms: [],
  networkActions: {},
  ...commonReducers.defaultState
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACTIONS.Types.LOGOUT: {
      return { ...defaultState };
    }

    case ACTIONS.Types.SET_ENVIRONMENT: {
      const { environment } = action;
      return { ...state, environment };
    }

    case ACTIONS.Types.SET_IDP_CONFIG: {
      const { idpConfig } = action;
      return { ...state, idpConfig };
    }

    case ACTIONS.Types.SET_USER: {
      const { user } = action;
      return { ...state, user };
    }

    case ACTIONS.Types.SET_ASSISTANCE_PROGRAMS: {
      const { assistancePrograms } = action;
      return { ...state, assistancePrograms };
    }

    case ACTIONS.Types.SET_SELECTED_ASSISTANCE_PROGRAM: {
      const { selectedAssistanceProgram } = action;
      return { ...state, selectedAssistanceProgram };
    }

    case ACTIONS.Types.SET_SHOW_ASSISTANCE_PROGRAM_MODAL: {
      const { showAssistanceProgramModal } = action;
      return { ...state, showAssistanceProgramModal };
    }

    case ACTIONS.Types.SET_SHOW_SUPPORT: {
      const { visible, assistanceProgram } = action;
      return { ...state, showSupport: { ...state.showSupport, visible, assistanceProgram } };
    }

    case ACTIONS.Types.CLEAR_ASSISTANCE_PROGRAMS: {
      return { ...state, assistancePrograms: [] };
    }

    case ACTIONS.Types.SET_NETWORK_ACTION: {
      const { actionType, isFetching, msg, code } = action;
      return { ...state, networkActions: { ...state.networkActions, [actionType]: { isFetching, msg, code } } };
    }

    case ACTIONS.Types.SET_OKTA_CONFIG: {
      const { oktaClientId } = action;
      return { ...state, oktaClientId };
    }

    case ACTIONS.Types.SET_NOTIFICATION_PREFERENCES: {
      const { notificationPreferences } = action;
      return { ...state, notificationPreferences };
    }

    default: {
      return commonReducers.reducer(state, action);
    }
  }
};

export default reducer;
